import axios from "axios";
import AuthService from "../auth/request";

const getCategories = () => {
    return new Promise((resolve, reject) => {
        AuthService.getAuthToken().then((response) => {
            let url = `api/v1/getAllCategories?proyect_id=${process.env.VUE_APP_PROYECT_ID}`;
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + response.access_token
            axios
                .get(
                    url
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch(reject);
        });
    });
};

export default {
    getCategories,
};